













import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Trigger, Symptom } from '@/data-service/types';
import { prettifyString } from '@/utils';

const OTHER = 'OTHER';

@Component
export default class SymptomsTriggersDisplay extends Vue {
  @Prop({ required: true }) triggers!: Trigger[];
  @Prop({ required: true }) symptoms!: Symptom[];

  jointValues(array: { type: string; value: string }[]) {
    if (!array.length) {
      return '-';
    }
    return array
      .map(element => {
        if (element.type === OTHER) {
          return element.value;
        } else {
          return prettifyString(element.type);
        }
      })
      .join(', ');
  }
}
